import { VERTICAL_MENU_WIDTH } from 'Navigation/VerticalMenu/VerticalMenu';
import { rem } from 'polished';
import styled from 'styled-components';
import { Breakpoints } from '@unmind/design-system/theme/deprecated';

const calcWidth = (size: Breakpoints) => rem(size + VERTICAL_MENU_WIDTH);

export const Section = styled('section')`
  h3 {
    margin-bottom: ${rem(12)};
  }

  .tag {
    padding: ${rem(6)};
    border-radius: ${rem(6)};
    margin-left: ${rem(12)};

    span {
      font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    }

    svg {
      width: ${rem(16)};
      height: ${rem(16)};
      margin-right: ${rem(2)};
    }

    svg:last-of-type {
      margin-right: ${rem(8)};
    }
  }

  ul {
    display: grid;
    gap: ${rem(16)};
    list-style: none;
    padding: 0;
    margin-top: ${rem(24)};
    grid-template-columns: repeat(1, 1fr);

    @media (min-width: ${calcWidth(Breakpoints.XS)}) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &:not(:last-of-type) {
    margin-bottom: ${rem(48)};
  }
`;
